import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MemoriesService } from "../../../services/memories/memories.service";
import { VideoService } from '../../../services/video/video.service';


@Component({
  selector: 'app-videocount',
  templateUrl: './videocount.component.html',
  styleUrls: ['./videocount.component.scss']
})
export class VideocountComponent implements OnInit {
//  memories : any[] =[];
  allUsersVideosCount: any[] = [];
  //allUsersVideosCount:any;
  isLoad = true;
memories : any[] =[];
 
  videoCount: any;
  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    public vcRef: ViewContainerRef,
    private videoService: VideoService    
  ) { }

  ngOnInit(): void {
    this.GetAllUserMemoriesVideoCountList();
    this.GetAllVideosCount();
  }
  // getMemoryList() {   
  //  // debugger;
  //   this.isLoad = false;
  //   this.memoriesService.getMemoriesList().subscribe((res: any) => {  
  //     //this.memories = res.memories || res;     
  //     this.memories = res;     
     
  //   })   
  // }
  GetAllVideosCount() {
    this.videoService.getAllVideosCount().subscribe((res: any) => {
      this.videoCount = res;
      // console.log('memoriesCount:', res.activeCount)
    })
  }
  GetAllUserMemoriesVideoCountList() {
  this.isLoad = false;
    this.videoService.GetAllUserMemoriesVideoCount().subscribe((res: any) => {
      this.allUsersVideosCount = res;     
    })
  }
}
